import type { DateMode, DetailMetric, MovementDateMetric, ControlStockRow } from "./types";

export const DETAIL_METRIC_OPTIONS: Array<{ value: DetailMetric; label: string }> = [
  { value: "inventarioInicial", label: "Inventario inicial" },
  { value: "compras", label: "Compras" },
  { value: "remisionPositiva", label: "Remisiones (+)" },
  { value: "remisionNegativa", label: "Remisiones (-)" },
  { value: "ventas", label: "Ventas por consumo" },
  { value: "ajusteNegativo", label: "Merma" },
  { value: "inventarioFinal", label: "Inventario final" },
];

export const MOVEMENT_DATE_METRIC_OPTIONS: Array<{
  value: MovementDateMetric;
  label: string;
}> = [
  { value: "compras", label: "Compras" },
  { value: "remisiones", label: "Remisiones" },
  { value: "ventas", label: "Ventas por consumo" },
  { value: "mermas", label: "Mermas" },
];

export const DATE_MODE_OPTIONS: Array<{
  key: DateMode;
  label: string;
  description: string;
  icon: string;
}> = [
  {
    key: "day",
    label: "Día",
    description: "Filtrar por un único día",
    icon: "ri-calendar-line",
  },
  {
    key: "week",
    label: "Semana",
    description: "Filtrar por semana calendario ISO",
    icon: "ri-calendar-line",
  },
  {
    key: "month",
    label: "Mes",
    description: "Filtrar por un mes completo",
    icon: "ri-calendar-event-line",
  },
  {
    key: "range",
    label: "Rango",
    description: "Selecciona una fecha de inicio y fin",
    icon: "ri-calendar-check-line",
  },
];

export const DATE_MODE_MAP = DATE_MODE_OPTIONS.reduce<
  Record<DateMode, (typeof DATE_MODE_OPTIONS)[number]>
>((acc, option) => {
  acc[option.key] = option;
  return acc;
}, {} as Record<DateMode, (typeof DATE_MODE_OPTIONS)[number]>);

export const METRIC_FIELDS: Array<keyof ControlStockRow> = [
  "inventarioInicial",
  "compras",
  "remisionPositiva",
  "remisionNegativa",
  "ventas",
  "ajustePositivo",
  "ajusteNegativo",
  "teorico",
  "inventarioFinal",
  "diferencia",
];

export const PDF_METRIC_KEYS = [
  "inventarioInicial",
  "compras",
  "remisionPositiva",
  "remisionNegativa",
  "ventas",
  "ajusteNegativo",
  "teorico",
  "inventarioFinal",
  "diferencia",
] as const;

export const NULL_OPTION_VALUE = "__null__";
